export const mapKey = '97b0623a16e8a07283e0d1ce12875e11';
export const mapSecretKey = 'affcaef809ef7a54ac733e6630deba26';

export const apiUrl = //process.env.NODE_ENV === 'development' ? 'http://localhost:6521' :
                     (window.location.protocol === 'https:' ? 'https://jy.api.x37b.cc' : 'http://175.178.170.78:8561');